module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-title-block"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('modal-campaign')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v("\n          Nuevo codigo\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-paquete"
  }, [_c('section', {
    staticClass: "u-table p-4"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.codigoCampa), function(data) {
    return _c('div', {
      key: data.id,
      staticClass: "u-row py-3",
      staticStyle: {
        "display": "grid"
      }
    }, [_c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v(_vm._s(data.code))]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("\n          " + _vm._s(data.description) + "\n        ")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": data.img,
        "alt": "",
        "width": "100"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("USD " + _vm._s(data.amount))]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_vm._v("4")]), _vm._v(" "), _c('p', {
      staticClass: "p-0 m-0"
    }, [_c('span', {
      staticClass: "d-block mb-2"
    }, [_c('span', {
      staticClass: "d-block",
      staticStyle: {
        "opacity": "0.75",
        "font-weight": "600",
        "font-size": "12px"
      }
    }, [_vm._v("Fecha inicio")]), _vm._v("\n            " + _vm._s(data.start_date) + "\n          ")]), _vm._v(" "), _c('span', {
      staticClass: "d-block"
    }, [_c('span', {
      staticClass: "d-block",
      staticStyle: {
        "opacity": "0.75",
        "font-weight": "600",
        "font-size": "12px"
      }
    }, [_vm._v("Fecha expiración")]), _vm._v("\n            " + _vm._s(data.end_date) + "\n          ")])])])
  })], 2)]), _vm._v(" "), _c('dialog', {
    attrs: {
      "id": "modal-campaign"
    }
  }, [_c('article', {
    staticClass: "u-modal"
  }, [_c('form', {
    staticClass: "u-modal-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCode.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-block-text d-flex justify-content-between"
  }, [_c('span', [_vm._v("Agregar nuevo código")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal('modal-campaign')
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "rgba(0, 0, 0, 1)",
      "transform": "",
      "msfilter": ""
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Cantidad ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.max_amount),
      expression: "form.max_amount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.max_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "max_amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pr-0"
  }, [_c('label', [_vm._v("Monto ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amount),
      expression: "form.amount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amount", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Fecha inicio")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.start_date),
      expression: "form.start_date"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "start_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 pl-0"
  }, [_c('label', [_vm._v("Fecha expiración")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.end_date),
      expression: "form.end_date"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "name": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "end_date", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control input",
    attrs: {
      "type": "file",
      "name": "",
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-auto d-block mt-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Registrar ingreso\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Campañas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-row u-row--header",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Código")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Imagen")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Monto")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Cantidad")]), _vm._v(" "), _c('h4', {
    staticClass: "u-row__title"
  }, [_vm._v("Fecha")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af62fa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/CodigoComponent.vue
// module id = 1848
// module chunks = 1